import { Provider, InjectionToken } from '@angular/core';
import {
  CONFIG_MANAGER_CONFIG_TOKEN,
  ConfigManagerConfig,
  IS_SUPERADMIN_TOKEN,
  PARTNER_ID_TOKEN,
  USER_ID_TOKEN,
} from './tokens';
import { ConfigManagerService } from './services/config-manager.service';
import { isObservable, Observable, of } from 'rxjs';

export function provideConfigManager(config: InjectionToken<ConfigManagerConfig>): Provider[] {
  return [
    ConfigManagerService,
    { provide: CONFIG_MANAGER_CONFIG_TOKEN, useExisting: config },
    {
      provide: PARTNER_ID_TOKEN,
      deps: [CONFIG_MANAGER_CONFIG_TOKEN],
      useFactory: partnerIdFactory,
    },
    {
      provide: IS_SUPERADMIN_TOKEN,
      deps: [CONFIG_MANAGER_CONFIG_TOKEN],
      useFactory: isSuperAdminFactory,
    },
    {
      provide: USER_ID_TOKEN,
      deps: [CONFIG_MANAGER_CONFIG_TOKEN],
      useFactory: userIdFactory,
    },
  ];
}

function partnerIdFactory(config: ConfigManagerConfig): Observable<string | undefined | null> {
  return isObservable(config.partnerId$) ? config.partnerId$ : of(config.partnerId$);
}

function isSuperAdminFactory(config: ConfigManagerConfig): Observable<boolean> {
  if (!config.isSuperAdmin$) {
    return of(false);
  }
  return isObservable(config.isSuperAdmin$) ? config.isSuperAdmin$ : of(config.isSuperAdmin$);
}

function userIdFactory(config: ConfigManagerConfig): Observable<string | undefined> {
  if (!config.userId$) {
    return of(undefined);
  }
  return isObservable(config.userId$) ? config.userId$ : of(config.userId$);
}

